import { render, staticRenderFns } from "./YcHome.vue?vue&type=template&id=5ffefd04&scoped=true"
import script from "./YcHome.vue?vue&type=script&lang=js"
export * from "./YcHome.vue?vue&type=script&lang=js"
import style0 from "./YcHome.vue?vue&type=style&index=0&id=5ffefd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffefd04",
  null
  
)

export default component.exports